<template>
    <div>
        <apexchart ref="trainingChart" type="line" height="400" :options="chartOptions" :series="series"/>
        <h5 style="display: none;">{{trainingId}} {{ timeMinutes }} {{iapValue}}</h5>
    </div>
</template>

<script>
import _ from "lodash";

const training = {
        t0: {
            title: "Очень лёгкая креатинфосфатная тренировка - 1",
            data: [80, 90, 100, 120, 130, 130, 140, 142, 100, 95, 130, 140, 140, 140, 145, 110, 100, 130, 140, 140, 140, 145, 110,
                100, 130, 140, 145, 145, 150, 120, 110, 130, 140, 145, 145, 150, 120, 110, 130, 140, 145, 145, 150, 120, 110, 130,
                145, 150, 150, 155, 130, 110, 130, 145, 150, 150, 155, 130, 110, 130, 145, 150, 150, 155, 130, 110, 100]
        },
        t1: {
            title: "Очень лёгкая креатинфосфатная тренировка - 2",
            data: [80, 90, 100, 130, 145, 120, 115, 110, 100, 140, 150, 130, 120, 110, 110, 150, 160, 130, 120, 110, 110, 150,
                160, 130, 120, 110, 110, 150, 165, 140, 130, 120, 120, 160, 170, 140, 130, 120, 120, 166, 172, 140, 130, 100, 100]
        },
        t2: {
            title: "Лёгкая креатинфосфатная тренировка - 1",
            data: [80, 90, 100, 130, 140, 140, 140, 140, 120, 110, 130, 140, 140, 140, 140, 120, 110, 140, 150, 150, 150, 150, 130,
                110, 140, 150, 150, 150, 150, 130, 110, 140, 150, 150, 150, 150, 130, 110, 140, 155, 155, 155, 155, 135, 115, 145,
                155, 160, 160, 160, 135, 115, 145, 155, 160, 160, 160, 135, 115, 145, 160, 160, 160, 160, 140, 130, 115]
        },
        t3: {
            title: "Лёгкая креатинфосфатная тренировка - 2",
            data: [80, 90, 134, 144, 150, 150, 152, 152, 110, 144, 148, 152, 152, 155, 155, 115, 144, 148, 152, 152, 155, 155, 115,
                144, 148, 152, 152, 155, 155, 115, 144, 148, 152, 152, 155, 155, 115, 144, 148, 152, 152, 155, 155, 115, 144, 148,
                152, 152, 155, 155, 115, 144, 148, 152, 152, 155, 155, 115, 144, 148, 152, 152, 155, 155, 115, 144, 148, 152, 152,
                155, 155, 115, 110, 105]
        },
        t4: {
            title: "Креатинфосфатная тренировка (средней тяжести)",
            data: [80, 90, 100, 130, 140, 140, 140, 148, 148, 152, 152, 120, 100, 144, 162, 162, 168, 130, 110, 144, 162, 162, 168,
                130, 110, 144, 162, 162, 168, 130, 110, 156, 168, 168, 172, 140, 120, 156, 168, 168, 172, 140, 120, 160, 170, 170,
                178, 140, 125, 160, 170, 170, 178, 140, 125, 168, 172, 172, 180, 130, 120, 110]
        },
        t5: {
            title: "Тяжёлая креатинфосфатная тренировка",
            data: [80, 100, 120, 160, 140, 130, 120, 166, 140, 130, 130, 170, 150, 147, 140, 176, 150, 147, 140, 176, 150, 147,
                140, 176, 150, 147, 140, 176, 150, 147, 140, 176, 150, 147, 140, 176, 150, 140, 130, 120, 110, 100]
        },
        t6: {
            title: "Очень лёгкая аэробно-анаэробная тренировка",
            data: [90, 100, 120, 140, 140, 140, 140, 140, 140, 142, 142, 142, 142, 142, 142, 147, 147, 147, 147, 147, 147, 147,
                147, 150, 150, 150, 150, 150, 150, 150, 150, 152, 152, 152, 152, 152, 152, 152, 152, 156, 156, 156, 156, 156,
                156, 156, 156, 156, 160, 160, 160, 160, 160, 160, 162, 162, 130, 110, 100]
        },
        t7: {
            title: "Лёгкая аэробно-анаэробная тренировка",
            data: [80, 100, 120, 140, 140, 140, 142, 142, 142, 146, 146, 146, 148, 148, 150, 150, 152, 152, 154, 154, 154, 156,
                156, 156, 158, 158, 160, 160, 160, 162, 162, 162, 164, 164, 164, 166, 166, 168, 168, 170, 170, 170, 172, 172,
                172, 176, 176, 176, 140, 120, 110]
        },
        t8: {
            title: "Аэробно-анаэробная тренировка средней тяжести",
            data: [90, 100, 120, 140, 140, 140, 140, 140, 140, 147, 147, 147, 147, 147, 147, 150, 150, 150, 150, 150, 150, 157,
                157, 157, 157, 157, 157, 160, 160, 160, 160, 160, 160, 167, 167, 167, 167, 167, 167, 170, 170, 170, 170, 170,
                170, 177, 177, 177, 177, 177, 177, 180, 182, 182, 182, 180, 177, 177, 170, 167, 150, 140, 130]
        },
        t9: {
            title: "Тяжёлая аэробно-анаэробная тренировка",
            data: [90, 100, 142, 142, 142, 142, 142, 148, 148, 148, 148, 148, 148, 148, 148, 156, 156, 156, 156, 156, 156, 156,
                158, 158, 158, 158, 162, 162, 162, 162, 162, 162, 168, 168, 168, 168, 168, 168, 168, 168, 168, 168, 168, 168,
                172, 172, 172, 172, 172, 172, 178, 178, 178, 178, 178, 178, 178, 150, 130]
        },
        t10: {
            title: "Очень тяжёлая аэробно-анаэробная тренировка",
            data: [90, 100, 140, 140, 140, 140, 140, 140, 145, 145, 145, 145, 145, 145, 150, 150, 150, 150, 150, 150, 155, 155,
                155, 155, 155, 155, 160, 160, 160, 160, 160, 160, 165, 165, 165, 165, 165, 165, 170, 170, 170, 170, 170, 170,
                175, 175, 175, 175, 175, 175, 180, 180, 180, 180, 180, 180, 140, 120, 100]
        },
        t11: {
            title: "Очень лёгкая лактатная тренировка",
            data: [80, 90, 100, 120, 124, 128, 132, 136, 140, 140, 140, 105, 95, 130, 134, 138, 142, 142, 142, 105, 95, 130,
                134, 138, 142, 142, 142, 105, 95, 132, 136, 140, 144, 144, 144, 115, 105, 132, 136, 140, 144, 144, 144, 115,
                105, 134, 138, 142, 146, 146, 146, 115, 105, 136, 140, 144, 148, 148, 148, 115, 105, 95]
        },
        t12: {
            title: "Лёгкая лактатная тренировка",
            data: [80, 90, 100, 130, 140, 140, 150, 150, 160, 160, 166, 130, 100, 140, 150, 150, 160, 160, 168, 135, 115, 140,
                150, 150, 160, 160, 168, 135, 115, 147, 156, 156, 166, 166, 170, 140, 120, 150, 158, 158, 164, 164, 172, 140,
                120, 152, 160, 160, 168, 168, 174, 140, 120, 154, 166, 166, 170, 170, 176, 140, 120, 110]
        },
        t13: {
            title: "Лактатная тренировка средней тяжести",
            data: [80, 80, 90, 90, 100, 110, 120, 130, 140, 150, 160, 166, 166, 166, 166, 176, 176, 176, 156, 146, 110, 150,
                156, 160, 166, 166, 166, 166, 176, 176, 176, 176, 156, 136, 120, 156, 166, 166, 166, 166, 166, 176, 176, 176,
                176, 176, 156, 136, 126, 156, 166, 166, 166, 166, 176, 176, 176, 176, 176, 176, 156, 146, 130, 130]
        },
        t14: {
            title: "Тяжёлая лактатная тренировка",
            data: [96, 140, 146, 150, 150, 150, 150, 150, 156, 156, 156, 156, 156, 156, 160, 160, 160, 160, 160, 130, 120, 110,
                156, 160, 160, 166, 166, 166, 166, 170, 170, 170, 170, 172, 172, 172, 172, 135, 125, 120, 166, 166, 168, 168,
                168, 168, 172, 172, 172, 172, 178, 178, 178, 178, 180, 180, 135, 120]
        },
        t15: {
            title: "Очень лёгкая смешанная тренировка",
            data: [80, 90, 100, 135, 135, 135, 120, 115, 115, 140, 140, 140, 125, 120, 120, 145, 145, 145, 130, 125, 125, 150,
                150, 150, 135, 130, 130, 155, 155, 155, 140, 135, 135, 160, 160, 160, 120, 100]
        },
        t16: {
            title: "Лёгкая смешанная тренировка",
            data: [80, 90, 100, 130, 130, 130, 130, 130, 130, 140, 140, 140, 140, 140, 140, 140, 150, 150, 150, 150, 150, 150,
                150, 150, 100, 100, 140, 140, 140, 147, 147, 147, 147, 152, 152, 152, 152, 105, 105, 142, 142, 142, 150, 150,
                150, 150, 157, 157, 157, 157, 110, 110, 145, 145, 145, 155, 155, 155, 155, 162, 162, 162, 162, 115, 105, 100]
        },
        t17: {
            title: "Смешанная тренировка средней тяжести",
            data: [80, 90, 100, 130, 140, 140, 140, 140, 150, 150, 150, 150, 156, 156, 156, 156, 156, 160, 160, 160, 162, 162,
                162, 170, 170, 170, 150, 120, 110, 140, 152, 152, 152, 152, 156, 158, 158, 158, 158, 162, 162, 168, 168, 168,
                172, 172, 160, 130, 120, 150, 160, 160, 166, 166, 170, 170, 172, 172, 178, 160, 130, 120]
        },
        t18: {
            title: "Тяжёлая смешанная тренировка",
            data: [90, 100, 130, 140, 150, 160, 160, 166, 166, 166, 166, 166, 168, 168, 168, 168, 172, 172, 172, 140, 120, 160,
                160, 166, 166, 166, 168, 168, 168, 172, 172, 140, 120, 140, 155, 125, 140, 155, 125, 140, 155, 125, 150, 160,
                168, 168, 172, 172, 140, 120, 140, 155, 125, 140, 155, 125, 140, 155, 125, 150, 160, 168, 168, 172, 172, 140, 120]
        },
        t19: {
            title: "Очень тяжёлая смешанная тренировка - 1",
            data: [80, 90, 130, 136, 132, 134, 136, 138, 140, 142, 144, 146, 148, 150, 152, 154, 156, 158, 160, 158, 156, 154,
                152, 150, 158, 160, 162, 164, 166, 166, 168, 168, 166, 164, 162, 160, 158, 166, 168, 170, 170, 172, 172, 174,
                174, 172, 170, 168, 166, 164, 170, 170, 172, 172, 174, 174, 178, 178, 164, 144, 134]
        },
        t20: {
            title: "Очень тяжёлая смешанная тренировка - 2",
            data: [80, 90, 100, 140, 140, 140, 147, 147, 147, 147, 155, 155, 155, 155, 160, 160, 160, 170, 170, 170, 125, 160,
                160, 160, 165, 165, 165, 170, 170, 170, 175, 175, 140, 160, 170, 170, 180, 180, 150, 130, 165, 175, 175, 182,
                182, 182, 150, 168, 175, 175, 182, 182, 160, 130, 168, 175, 175, 175, 182, 182, 160, 130]
        },
        t21: {
            title: "Очень тяжёлая смешанная тренировка - 3",
            data: [90, 100, 130, 140, 150, 150, 155, 155, 155, 160, 160, 160, 165, 165, 165, 168, 168, 168, 168, 140, 120, 155,
                125, 160, 125, 165, 125, 150, 165, 168, 172, 172, 140, 130, 160, 130, 165, 130, 175, 135, 160, 165, 170, 175,
                175, 150, 135, 165, 135, 170, 135, 175, 135, 160, 165, 170, 175, 180, 140, 130]
        },
        t22: {
            title: "Полумарафон деда Захара",
            data: [90, 100, 147, 147, 147, 147, 147, 147, 147, 147, 147, 147, 147, 147, 147, 147, 147, 147, 147, 147, 147, 156,
                156, 156, 156, 156, 156, 156, 156, 156, 156, 156, 156, 156, 156, 156, 156, 156, 156, 156, 156, 156, 162, 162,
                162, 162, 162, 162, 162, 162, 162, 162, 162, 162, 162, 162, 162, 162, 162, 162, 162, 162, 162, 162, 166, 166,
                166, 166, 166, 166, 166, 166, 166, 166, 166, 166, 166, 168, 168, 168, 168, 168, 168, 168, 168, 168, 168, 172,
                172, 172, 172, 172, 172, 172, 172, 172, 172, 172, 172, 172, 172, 172, 172, 172, 172, 172, 172, 172, 172, 172,
                174, 174, 174, 174, 174, 174, 174, 176, 176, 176, 176, 176, 176, 176, 178, 178, 178, 178, 178, 178, 178, 178,
                178, 156, 154, 152]
        }
    };

    let colors = ['#dc3545'];
    export default {
        props: {
            id: {
                type: String,
                default: '',
            },
            hrMin: {
                type: Number,
                default: 40,
            },
            hrMax: {
                type: Number,
                default: 220,
            },
            trainingId: {
                type: String,
                default: '',
            },
            timeMinutes: {
                type: Number,
                default: 60 * 60,
            },
            iapValue: {
                type: Number,
                default: 1,
            }
        },
        created: function () {
            this.updateWave();
        },
        updated: function () {
            let data = this.updateWave();
            this.$refs.trainingChart.updateSeries([{
                data: data
            }]);
        },
        data() {
            return {
                series: [{
                    name: 'Пульс',
                    type: 'line',
                    data: [],
                    show: true,
                    opposite: false,
                    axisTicks: {
                        show: true,
                    },
                    axisBorder: {
                        show: true,
                        color: '#1d2124'
                    },
                    labels: {
                        style: {
                            color: '#1d2124',
                        },
                        minWidth: 1,
                        maxWidth: 160,
                    },
                    tooltip: {
                        enabled: false
                    }
                }],
                chartOptions: {
                    chart: {
                        id: this.id,
                        shadow: {
                            enabled: true,
                            color: '#000',
                            top: 18,
                            left: 7,
                            blur: 10,
                            opacity: 1
                        },
                        toolbar: {
                            show: false
                        }
                    },
                    annotations: {
                        yaxis: [{
                            y: this.hrMin,
                            y2: this.hrMax,
                            borderColor: '#ffc107',
                            fillColor: '#ffc107',
                            opacity: 0.3,
                            label: {
                                borderColor: '#333',
                                style: {
                                    fontSize: '10px',
                                    color: '#333',
                                    background: '#FEB019',
                                },
                                text: ' ',
                            }
                        }],
                    },
                    colors: colors,
                    dataLabels: {
                        enabled: false,
                    },
                    stroke: {
                        show: true,
                        width: 3,
                        curve: 'smooth'
                    },
                    xaxis: {
                        type: 'datetime',
                        title: {
                            text: 'минуты'
                        },
                        labels: {
                            format: 'mm',
                        }
                    },
                    yaxis: [{
                        seriesName: 'Пульс',
                        title: {
                            text: 'каденс, шагов/мин',
                            style: {
                                color: '#1d2124',
                            }
                        },
                        show: true,
                        opposite: false,
                        min: 40,
                        max: 220,
                        axisTicks: {
                            show: true,
                        },
                        axisBorder: {
                            show: true,
                            color: '#1d2124'
                        },
                        labels: {
                            style: {
                                color: '#1d2124',
                            },
                            minWidth: 1,
                            maxWidth: 160,
                        },
                        tooltip: {
                            enabled: false
                        }
                    }, {
                        seriesName: 'TEAM B',
                        title: {
                            text: 'каденс, шагов/мин',
                            style: {
                                color: '#1d2124',
                            }
                        },
                        show: true,
                        opposite: true,
                        min: 40,
                        max: 220,
                        axisTicks: {
                            show: true,
                        },
                        axisBorder: {
                            show: true,
                            color: '#1d2124'
                        },
                        labels: {
                            style: {
                                color: '#1d2124',
                            },
                            minWidth: 1,
                            maxWidth: 160,
                        },
                        tooltip: {
                            enabled: false
                        }
                    }
                    ],
                    tooltip: {
                        followCursor: false,
                        theme: 'dark',
                        x: {
                            show: false,
                            format: 'mm'
                        },
                        marker: {
                            show: false,
                        },
                        y: {
                            title: {
                                formatter: function () {
                                    return '';
                                }
                            }
                        }
                    },
                    legend: {
                        show: false,
                    },
                }
            }
        },
        methods: {
            updateWave: function () {
                this.series[0].data.splice(0);
                let data = _.slice(training[this.trainingId].data, 0, Math.min(this.timeMinutes, training[this.trainingId].data.length));
                let chartData = this.series[0].data;
                chartData.push([new Date().setMinutes(0), null]);
                data.forEach((item, i) => {
                    chartData.push([new Date().setMinutes(i + 1), Math.round(Math.max(40, Math.min(item * this.iapValue / 166.0, 220)))]);
                });
                chartData.push([new Date().setMinutes(data.length + 1), null]);
                return chartData;
            },
        }
    }
</script>